export const state = {
    genres: [],
}

export const getters = {
    activeGenres(state) {
        return state.genres
            .filter(genre => genre.status === 'open')
            .sort((a, b) => (a.name > b.name ? 1 : a.name < b.name ? -1 : 0))
    },
}

export const mutations = {
    SET_GENRES(state, genres) {
        state.genres = genres
    },
}

export const actions = {}
